export const HomeIndex = () => {
  return (
    <div className="container py-5">
      <div className="row align-items-center mb-5">
        <div className="col-md-6">
          <h1 className="display-4 fw-bold mb-3">Baby Activity Tracker</h1>
          <p className="lead mb-4">
            Easily track your baby's feedings and diaper changes. Keep your
            baby's routine organized and ensure nothing important gets missed.
          </p>
          <a href="#track-activity" className="btn btn-primary btn-lg me-2">
            Track Activity
          </a>
          <a href="#learn-more" className="btn btn-outline-secondary btn-lg">
            Learn More
          </a>
        </div>
        <div className="col-md-6 text-center">
          <img
            src="https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=500&q=80"
            alt="Baby Tracker"
            className="img-fluid rounded shadow"
            style={{ maxHeight: "300px", objectFit: "cover" }}
          />
        </div>
      </div>

      <div className="row text-center mb-5">
        <div className="col-md-4 mb-4">
          <div className="card h-100 border-0 shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Track Feedings</h5>
              <p className="card-text">
                Log bottle or breastfeeding sessions with notes on amount, time,
                and notes for each feeding.
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-4 mb-4">
          <div className="card h-100 border-0 shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Monitor Diaper Changes</h5>
              <p className="card-text">
                Quickly record every diaper change, noting wet, dirty, or both,
                and any details for easy tracking.
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-4 mb-4">
          <div className="card h-100 border-0 shadow-sm">
            <div className="card-body">
              <h5 className="card-title">View Activity History</h5>
              <p className="card-text">
                Get a clear history of your baby’s activities so you never miss
                a pattern or important milestone.
              </p>
            </div>
          </div>
        </div>
      </div>

      <section className="py-5 bg-light rounded" id="learn-more">
        <div className="row align-items-center">
          <div className="col-md-8">
            <h2 className="fw-bold mb-3">Why Use Baby Activity Tracker?</h2>
            <p className="mb-4">
              Our simple and intuitive interface helps parents and caregivers
              reliably keep track of feeding and diaper routines—whether at home
              or on-the-go. Stay organized and keep your baby happy and healthy!
            </p>
          </div>
          <div className="col-md-4 text-md-end text-center">
            <a href="#track-activity" className="btn btn-success btn-lg">
              Start Tracking
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};
